/** FNV-1a based incremental 32-bit hash for deterministic state fingerprints
 * (used to assert two simulations diverge/agree bit-for-bit). Not cryptographic. */
export class StateHasher {
  private h = 0x811c9dc5;

  /** Fold a 32-bit integer in. */
  int(value: number): this {
    let v = value >>> 0;
    for (let i = 0; i < 4; i++) {
      this.h ^= v & 0xff;
      this.h = Math.imul(this.h, 0x01000193) >>> 0;
      v >>>= 8;
    }
    return this;
  }

  /** Fold a float in (bit-exact via its IEEE-754 representation). */
  float(value: number): this {
    const buf = new Float64Array(1);
    buf[0] = value;
    const view = new Uint32Array(buf.buffer);
    return this.int(view[0] ?? 0).int(view[1] ?? 0);
  }

  get value(): number {
    return this.h >>> 0;
  }
}
